var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6372 6.36209C34.3904 7.11527 34.3904 8.3364 33.6372 9.08958L9.08983 33.6369C8.33665 34.3901 7.11552 34.3901 6.36234 33.6369C5.60917 32.8838 5.60917 31.6626 6.36234 30.9094L30.9097 6.36209C31.6629 5.60892 32.884 5.60892 33.6372 6.36209Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36282 6.36209C7.11599 5.60892 8.33713 5.60892 9.0903 6.36209L33.6377 30.9094C34.3908 31.6626 34.3908 32.8838 33.6377 33.6369C32.8845 34.3901 31.6633 34.3901 30.9102 33.6369L6.36282 9.08958C5.60965 8.3364 5.60965 7.11527 6.36282 6.36209Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7af1af95cc6089bd3236174179300b9f.svg";
export { ForwardRef as ReactComponent };